// AUTO-GENERATED GraphQL Builder for Payment
import * as Builders from '../';
export class PaymentBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  invoiceId(){ return this.add('invoiceId'); }
  gatewayRef(){ return this.add('gatewayRef'); }
  method(){ return this.add('method'); }
  amount(){ return this.add('amount'); }
  currencyCode(){ return this.add('currencyCode'); }
  status(){ return this.add('status'); }
  paidDate(){ return this.add('paidDate'); }
  paymentType(){ return this.add('paymentType'); }
  bookingScheduleId(){ return this.add('bookingScheduleId'); }
  gatewayOrderRef(){ return this.add('gatewayOrderRef'); }
  gatewaySignature(){ return this.add('gatewaySignature'); }
  failureReason(){ return this.add('failureReason'); }
  attemptedDate(){ return this.add('attemptedDate'); }
  rawJson(){ return this.add('rawJson'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  bookingSchedule(b?:(q:Builders.BookingScheduleBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingSchedule'))return this;
    this.v.add('bookingSchedule');
    const n=new Builders.BookingScheduleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingSchedule { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  invoice(b?:(q:Builders.InvoiceBuilder)=>void){
    if(this.depth>=5||this.v.has('invoice'))return this;
    this.v.add('invoice');
    const n=new Builders.InvoiceBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoice { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  ledgerEntryList(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntryList'))return this;
    this.v.add('ledgerEntryList');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  paymentEventList(b?:(q:Builders.PaymentEventBuilder)=>void){
    if(this.depth>=5||this.v.has('paymentEventList'))return this;
    this.v.add('paymentEventList');
    const n=new Builders.PaymentEventBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentEventList { ${inner} }`);
    return this;
  }

  paymentTransferList(b?:(q:Builders.PaymentTransferBuilder)=>void){
    if(this.depth>=5||this.v.has('paymentTransferList'))return this;
    this.v.add('paymentTransferList');
    const n=new Builders.PaymentTransferBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentTransferList { ${inner} }`);
    return this;
  }

  refundList(b?:(q:Builders.RefundBuilder)=>void){
    if(this.depth>=5||this.v.has('refundList'))return this;
    this.v.add('refundList');
    const n=new Builders.RefundBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`refundList { ${inner} }`);
    return this;
  }

  reverseLedgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  reversePaymentEvent(b?:(q:Builders.PaymentEventBuilder)=>void){
    const n=new Builders.PaymentEventBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentEventList { ${inner} }`);
    return this;
  }

  reversePaymentOrderResult(b?:(q:Builders.PaymentOrderResultBuilder)=>void){
    const n=new Builders.PaymentOrderResultBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentOrderResultList { ${inner} }`);
    return this;
  }

  reversePaymentSplitResult(b?:(q:Builders.PaymentSplitResultBuilder)=>void){
    const n=new Builders.PaymentSplitResultBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentSplitResultList { ${inner} }`);
    return this;
  }

  reversePaymentTransfer(b?:(q:Builders.PaymentTransferBuilder)=>void){
    const n=new Builders.PaymentTransferBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`paymentTransferList { ${inner} }`);
    return this;
  }

  reverseRefund(b?:(q:Builders.RefundBuilder)=>void){
    const n=new Builders.RefundBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`refundList { ${inner} }`);
    return this;
  }
}
